import { uniqBy } from 'lodash';
import categories from '../data/supportCategories.json';
import RestService from './RestService';

const getArticlesByCategory = async (queryParam) => {
  const uri = `/api/graphql/v1/faq?q={faq(category:"${queryParam}"){questions{question answer id}}}`;
  const response = await RestService.get(uri);
  return uniqBy(response.entity.faq[0].questions, 'id');
};

const getCategories = () => Promise.resolve(categories);

const SupportService = {
  getArticlesByCategory,
  getCategories
};

export default SupportService;



/** WEBPACK FOOTER **
 ** ./src/services/SupportService.js
 **/